// emit standard 'KO' alert toast on backend KO
// BUT we can skip any mutation by name and handle it manually
import {uiBus} from '@/plugins/uiBus';
import {ResponseHandler} from '@/helpers/ResponseHandler';
import {IErrors} from "@/model/IErrors";

// some operations are expected to result in a KO, these can be silenced so KO toast won't pop
uiBus.on('backend.call.KO', (mutationName: string, errors: IErrors) => {
  const silencedMutationNames: string[] = [
    'permissionTargetsLoaded',
    'emailComposed',
    'emailForwarded',
    'emailReplied',
    'emailSent',
    'templateReplySent',
  ];
  if (silencedMutationNames.indexOf(mutationName) === -1) {
    if (errors._ && errors._[0]) {
      uiBus.emit('alert', 'KO - ' + errors._[0]);
    }
    else {
      uiBus.emit('alert', 'KO');
    }
  }
});

// using a dummy error translator for now, as we don't have translations for errors in modulo yet
const responseHandler = new ResponseHandler(
  uiBus,
  // (errors: IErrors) => errors
);
// make sure we don't carry over debounced data as it would prevent reloading data which resulted in a 401
uiBus.on('backend.call.KO', () => {
  responseHandler.clearDebounce();
});

export default responseHandler;
